import { getApi } from "./core";
export async function getStatsOverview() {
    const resp = await getApi(`stats/overview`);
    return resp;
}
